// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__17Hv6","right":"Footer_right__29zBd","buttons":"Footer_buttons__3qCh5"};